<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/securite-evenementielle.png'" [alt]="'securite-evenementielle'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Sécurité <br> événementielle
                    </h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>Vous organisez un <br>événement...</h2>
                <ul class="mb-2">
                    <li>Festival</li>
                    <li>Foire</li>
                    <li>Concert</li>
                    <li>exposition</li>
                    <li>soirée privée</li>
                    <li>soirée d'entreprise</li>
                    <li>Vernissage</li>
                    <li>Formule 1</li>
                    <li>Autres..</li>
                </ul>
                <p class="mb-4">Farco Security est là pour assurer que votre événement se déroule en toute sérénité.</p>
                <p>Nous agissons avec une « main de fer dans un gant de velours »</p>
            </div>
        </div>
    </div>
</section>